"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.MAPBOX_STYLE_KEYS = void 0;
exports.MAPBOX_STYLE_KEYS = {
  light: 'light-v10',
  dark: 'dark-v10',
  streets: 'streets-v11',
  outdoors: 'outdoors-v11',
  satellite: 'satellite-v9',
  "satellite-streets": 'satellite-streets-v11'
};